export default __webpack_public_path__ + "static/media/new-dropdown-arrow-blue.5305913d.svg";